module.exports = __webpack_public_path__ + "img/22.fc951a22.svg";